import Operation from './Operation.js';
import {deleteParameterAutomations} from './parameterAutomations.js';
import DeleteEvent from './DeleteEvent.js';
import InsertEvent from './InsertEvent.js';
import {deletePatternsSelection} from './deletePatternsSelection.js';
import DeleteCompoundEvent from './DeleteCompoundEvent.js';
import {constructEvent} from 'session/constants.js';
import {SEQUENCE_ROLL} from 'session/constants.js';
import SplitPianoRollPattern from './SplitPianoRollPattern.js';

const DETERMINISTIC = 'DETERMINISTIC';
const LINEAR = 'LINEAR';
const BASIC = 'BASIC';

class DeleteSelection extends Operation {
    constructor(mix, selection) {
        super(mix, undefined);

        this.selection = selection;
        this.start = this.selection.start;
        this.end = this.selection.end;
    }

    execute() {
        if (this.mix.subSequence === undefined) {
            // then we only do sequence roll
            let mixByType = this.mix.deterministicMixesByType[SEQUENCE_ROLL];
            this.deleteByType(SEQUENCE_ROLL, mixByType);
            return;
        }

        for (let type in this.mix.mixesByType) {
            let mixByType = this.mix.mixesByType[type];
            this.deleteByType(parseInt(type), mixByType);
        }

        for (let type in this.mix.deterministicMixesByType) {
            let mixByType = this.mix.deterministicMixesByType[type];
            this.deleteByType(parseInt(type), mixByType);
        }

        if (this.mix.subSequence.isTrack) {
            this.executeForTrack(this.mix.subSequence.tracks[0]);
        }

        // now we need to delete every automation in the selection range
        // and roll it back 

        deleteParameterAutomations(this.mix.subSequence, this.start, this.end);
    }

    deleteByType(eventType, mixByType, mixType) {
        let events = mixByType.getEventsBetween(this.start, this.end, true)
            .filter(x => !x.isPrunable());

        for (let i in events) {
            let event = events[i];
            
            if (event.initialSubEvent !== undefined) {
                let subEvents = [... event.subEvents];
                for (let i in subEvents) {
                    new DeleteCompoundEvent(this.mix, event, subEvents[i])
                        .execute();
                }
                new DeleteCompoundEvent(this.mix, event, event.initialSubEvent)
                    .execute();
            } else {
                new DeleteEvent(this.mix, event, true)
                    .execute();
            }
        }

        if (mixByType.getMixType() === LINEAR) {
            let startEvent = constructEvent(eventType);
            if (startEvent !== undefined) {
                let startValue= mixByType.getValueAtStep(this.start);
                let endEvent = constructEvent(eventType);
                startEvent.step = this.start;
                endEvent.step = this.end - 1;
                startEvent.setValue(startValue);
                endEvent.setValue(startValue);
                
                startEvent.subSequence = this.mix.subSequence;
                endEvent.subSequence = this.mix.subSequence;

                new InsertEvent(this.mix, startEvent, 1)
                    .execute();
                new InsertEvent(this.mix, endEvent, 1)
                    .execute();
            }
        }
    }

    executeForTrack(track) {
        deletePatternsSelection(track, this.start, this.end);
   }
}

export default DeleteSelection;
